import { CustomerKeyType } from '../../constants';

export type Wishlist = {
  customerKey: string;
  wishlistId: number;
  customerKeyType: CustomerKeyType;
  skus: string[];
  createdAt: Date;
};

/**
 * Who a wishlist belongs to for the current visitor.
 *
 * A logged-in visitor is always owned by their account id, never by the stored guest key —
 * the WordPress wishlist page reads `get_current_user_id()`, so any other key renders empty there.
 */
export interface WishlistOwner {
  customerKey: string | undefined;
  customerKeyType: CustomerKeyType;
  isOwnerResolved: boolean;
}
